import { ClassNameProps, StyleProps } from "@hex-insights/core";
import { Post, User, UserNameAndImageFragment } from "../../../../Utilities";
import { AuthorTimestampView as GeneralAuthorTimestampView } from "../../_General/Author";

export type AuthorTimestampViewProps = {
	post: Pick<Post, "createdAt"> & {
		author: (Pick<User, "id"> & UserNameAndImageFragment) | null;
	};
	isNew?: boolean;
} & Partial<ClassNameProps & StyleProps>;

export function AuthorTimestampView({ post, isNew, className, style }: AuthorTimestampViewProps) {
	return (
		<GeneralAuthorTimestampView
			author={post.author}
			timestamp={post.createdAt}
			isNew={isNew}
			className={className}
			style={style}
		/>
	);
}
